import { useIsCompanyPath, useIsFirmPath, useIsFundPath } from 'utilities';
import { CompanyExcelExportDialog } from './CompanyExcelExportDialog';
import { FirmExcelExportDialog } from './FirmExcelExportDialog';
import { FundExcelExportDialog } from './FundExcelExportDialog';
import { BaseDialogProps } from './types';

export const ExcelExportDialogV2 = (props: BaseDialogProps) => {
  const isCompanyPage = useIsCompanyPath();
  const isFundPage = useIsFundPath();
  const isFirmPage = useIsFirmPath();

  if (isCompanyPage) {
    return <CompanyExcelExportDialog {...props} />;
  }

  if (isFundPage) {
    return <FundExcelExportDialog {...props} />;
  }

  if (isFirmPage) {
    return <FirmExcelExportDialog {...props} />;
  }

  return null;
};
